import * as React from 'react';
import Title from 'core/components/Title';
import * as styles from './RelatedArticles.module.scss';
import { BlogListEntry } from '../../lib/types';
import BlogCard from '../BlogCard';

export type RelatedArticlesProps = {
    entries: ReadonlyArray<BlogListEntry>;
};

function RelatedArticles({
    entries,
}: RelatedArticlesProps): React.ReactElement {
    const half = (entries.length - 1) / 2;

    const [translate, setTranslate] = React.useState(Math.max(0, half - 1));

    React.useEffect(() => {
        const onKeyUp = (event: KeyboardEvent) => {
            switch (event.code) {
                case 'ArrowRight':
                    setTranslate((prev) => Math.min(half, prev + 1));
                    break;
                case 'ArrowLeft':
                    setTranslate((prev) => Math.max(-half, prev - 1));
                    break;
                default:
                    // ignore;
                    break;
            }
        };
        document.addEventListener('keyup', onKeyUp);

        return () => {
            document.removeEventListener('keyup', onKeyUp);
        };
    }, [half]);

    const style = {
        '--translate': translate,
        '--number-of-items': entries.length,
    } as React.CSSProperties;

    return (
        <aside className={styles.root} style={style}>
            <Title
                title="You Might Also Like"
                className={styles.titleWrapper}
                titleClassName={styles.title}
            />
            <section
                className={styles.content}
                aria-roledescription="carousel"
                aria-label="Related articles"
            >
                {entries.map((entry, idx) => (
                    <BlogCard
                        entry={entry}
                        key={entry.id}
                        className={styles.card}
                        onClick={() => setTranslate(half - idx)}
                        onFocus={() => setTranslate(half - idx)}
                        tabIndex={0}
                    />
                ))}
            </section>
        </aside>
    );
}

export default RelatedArticles;
